<nz-card [nzTitle]="titleTpl" [nzExtra]="extraTpl" testId="theme-item-card">
  <ng-template #titleTpl>
    {{ themeId ? ('theme.item.title.edit' | i18n) : ('theme.item.title.create' | i18n) }}
    <nz-tag nzColor="gold" class="default-tag" *ngIf="isDefault" testId="theme-item-default-tag">{{
      'theme.item.default-theme' | i18n
    }}</nz-tag>
  </ng-template>
  <ng-template #extraTpl>
    <div class="card-header-actions" testId="theme-item-header-actions">
      <button nz-button nzType="default" (click)="back()" testId="theme-item-back-button"> {{ 'common.back' | i18n }} </button>
      <button nz-button nzType="primary" [nzLoading]="saving" (click)="save()" testId="theme-item-save-button">
        {{ 'common.save' | i18n }}
      </button>
      <button
        nz-button
        nzType="default"
        [nzLoading]="toggling"
        (click)="setAsDefault()"
        *ngIf="shouldShowSetDefaultButton()"
        testId="theme-item-set-default-button"
      >
        {{ 'theme.item.set-default' | i18n }}
      </button>
      <button
        nz-button
        nzType="default"
        [nzLoading]="toggling"
        (click)="enable()"
        *ngIf="shouldShowEnableButton()"
        testId="theme-item-enable-button"
      >
        {{ 'theme.status.enable' | i18n }}
      </button>
      <button
        nz-button
        nzType="default"
        [nzLoading]="toggling"
        (click)="disable()"
        *ngIf="shouldShowDisableButton()"
        testId="theme-item-disable-button"
      >
        {{ 'theme.status.disable' | i18n }}
      </button>
    </div>
  </ng-template>

  <nz-spin [nzSpinning]="loading" testId="theme-item-spin">
    <div class="editor-layout" testId="theme-item-layout">
      <div class="form-column">
        <div class="form-scroll">
          <form nz-form class="form" testId="theme-item-form">
            <div nz-form-item>
              <div nz-form-label>
                <label>{{ 'common.status' | i18n }}</label>
              </div>
              <div nz-form-control>
                <nz-tag [nzColor]="getStatusColor(status)">{{ getStatusText(status) }}</nz-tag>
              </div>
            </div>
            <div nz-form-item>
              <div nz-form-label>
                <label>{{ 'theme.item.is-default-theme' | i18n }}</label>
              </div>
              <div nz-form-control>
                <nz-tag nzColor="gold" *ngIf="isDefault">{{ 'common.yes' | i18n }}</nz-tag>
                <nz-tag *ngIf="!isDefault">{{ 'common.no' | i18n }}</nz-tag>
              </div>
            </div>
            <div nz-form-item>
              <div nz-form-label>
                <label nz-form-item-required>{{ 'theme.list.form.name' | i18n }}</label>
              </div>
              <div nz-form-control>
                <input
                  nz-input
                  [(ngModel)]="name"
                  name="name"
                  [placeholder]="'theme.list.form.name' | i18n"
                  testId="theme-item-name-input"
                />
              </div>
            </div>

            <div nz-form-item>
              <div nz-form-label>
                <label>{{ 'theme.list.form.description' | i18n }}</label>
              </div>
              <div nz-form-control>
                <textarea
                  nz-input
                  [(ngModel)]="description"
                  name="description"
                  rows="4"
                  [placeholder]="'theme.list.form.description' | i18n"
                  testId="theme-item-description-textarea"
                ></textarea>
              </div>
            </div>

            <div class="section-card">
              <h3 class="section-title">{{ 'theme.item.section.base-colors' | i18n }}</h3>
              <div class="grid two">
                <div nz-form-item>
                  <div nz-form-label
                    ><label>{{ 'theme.item.field.primary-color' | i18n }}</label></div
                  >
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input
                        type="color"
                        [(ngModel)]="themeConfig.primaryColor"
                        name="primaryColor"
                        testId="theme-item-primary-color-picker"
                      />
                      <input
                        nz-input
                        [(ngModel)]="themeConfig.primaryColor"
                        name="primaryColorHex"
                        testId="theme-item-primary-color-input"
                      />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label
                    ><label>{{ 'theme.item.field.background-color' | i18n }}</label></div
                  >
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input
                        type="color"
                        [(ngModel)]="themeConfig.backgroundColor"
                        name="backgroundColor"
                        testId="theme-item-background-color-picker"
                      />
                      <input
                        nz-input
                        [(ngModel)]="themeConfig.backgroundColor"
                        name="backgroundColorHex"
                        testId="theme-item-background-color-input"
                      />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.header-text-color' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input
                        type="color"
                        [(ngModel)]="themeConfig.headerTextColor"
                        name="headerTextColor"
                        testId="theme-item-header-text-color-picker"
                      />
                      <input
                        nz-input
                        [(ngModel)]="themeConfig.headerTextColor"
                        name="headerTextColorHex"
                        testId="theme-item-header-text-color-input"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="section-card">
              <h3 class="section-title">{{ 'theme.item.section.bubbles' | i18n }}</h3>
              <div class="grid two">
                <div nz-form-item>
                  <div nz-form-label
                    ><label>{{ 'theme.item.field.user-message-bg' | i18n }}</label></div
                  >
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input
                        type="color"
                        [(ngModel)]="themeConfig.customerBubbleBg"
                        name="customerBubbleBg"
                        testId="theme-item-customer-bubble-bg-picker"
                      />
                      <input
                        nz-input
                        [(ngModel)]="themeConfig.customerBubbleBg"
                        name="customerBubbleBgHex"
                        testId="theme-item-customer-bubble-bg-input"
                      />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label
                    ><label>{{ 'theme.item.field.user-message-text' | i18n }}</label></div
                  >
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input
                        type="color"
                        [(ngModel)]="themeConfig.customerBubbleText"
                        name="customerBubbleText"
                        testId="theme-item-customer-bubble-text-picker"
                      />
                      <input
                        nz-input
                        [(ngModel)]="themeConfig.customerBubbleText"
                        name="customerBubbleTextHex"
                        testId="theme-item-customer-bubble-text-input"
                      />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label
                    ><label>{{ 'theme.item.field.service-message-bg' | i18n }}</label></div
                  >
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input
                        type="color"
                        [(ngModel)]="themeConfig.agentBubbleBg"
                        name="agentBubbleBg"
                        testId="theme-item-agent-bubble-bg-picker"
                      />
                      <input
                        nz-input
                        [(ngModel)]="themeConfig.agentBubbleBg"
                        name="agentBubbleBgHex"
                        testId="theme-item-agent-bubble-bg-input"
                      />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label
                    ><label>{{ 'theme.item.field.service-message-text' | i18n }}</label></div
                  >
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input
                        type="color"
                        [(ngModel)]="themeConfig.agentBubbleText"
                        name="agentBubbleText"
                        testId="theme-item-agent-bubble-text-picker"
                      />
                      <input
                        nz-input
                        [(ngModel)]="themeConfig.agentBubbleText"
                        name="agentBubbleTextHex"
                        testId="theme-item-agent-bubble-text-input"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="section-card">
              <h3 class="section-title">{{ 'theme.item.section.ui-elements' | i18n }}</h3>
              <div class="grid two">
                <div nz-form-item>
                  <div nz-form-label
                    ><label>{{ 'theme.item.field.header-bg' | i18n }}</label></div
                  >
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input type="color" [(ngModel)]="themeConfig.headerBg" name="headerBg" testId="theme-item-header-bg-picker" />
                      <input nz-input [(ngModel)]="themeConfig.headerBg" name="headerBgHex" testId="theme-item-header-bg-input" />
                    </div>
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.footer-bg' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <div class="color-input-pair">
                      <input type="color" [(ngModel)]="themeConfig.footerBg" name="footerBg" testId="theme-item-footer-bg-picker" />
                      <input nz-input [(ngModel)]="themeConfig.footerBg" name="footerBgHex" testId="theme-item-footer-bg-input" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="section-card">
              <h3 class="section-title">{{ 'theme.item.section.radius-shadow' | i18n }}</h3>
              <div class="grid two">
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.bubble-radius' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <input nz-input [(ngModel)]="themeConfig.bubbleRadius" name="bubbleRadius" testId="theme-item-bubble-radius-input" />
                  </div>
                </div>
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.field.window-radius' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <input nz-input [(ngModel)]="themeConfig.windowRadius" name="windowRadius" testId="theme-item-window-radius-input" />
                  </div>
                </div>
                <div nz-form-item class="span-2">
                  <div nz-form-label>
                    <label>{{ 'theme.item.shadow.title' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <nz-select
                      [(ngModel)]="shadowPreset"
                      name="shadowPreset"
                      (ngModelChange)="onShadowPresetChange($event)"
                      style="width: 100%"
                      testId="theme-item-shadow-preset-select"
                    >
                      <nz-option [nzLabel]="'theme.item.shadow.preset.none' | i18n" nzValue="none" />
                      <nz-option [nzLabel]="'theme.item.shadow.preset.light' | i18n" nzValue="light" />
                      <nz-option [nzLabel]="'theme.item.shadow.preset.standard' | i18n" nzValue="standard" />
                      <nz-option [nzLabel]="'theme.item.shadow.preset.deep' | i18n" nzValue="deep" />
                      <nz-option [nzLabel]="'theme.item.shadow.preset.custom' | i18n" nzValue="custom" />
                    </nz-select>
                  </div>
                </div>
                <div nz-form-item class="span-2" *ngIf="shadowPreset === 'custom'">
                  <div nz-form-label>
                    <label>{{ 'theme.item.shadow.custom-placeholder' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <input
                      nz-input
                      class="full-width-input"
                      [(ngModel)]="shadowCustomValue"
                      name="shadowCustomValue"
                      (ngModelChange)="onShadowCustomValueChange($event)"
                      [placeholder]="'theme.item.shadow.custom-placeholder' | i18n"
                      style="background: #f3f3f5"
                      testId="theme-item-shadow-custom-input"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="section-card">
              <h3 class="section-title">{{ 'theme.item.font.title' | i18n }}</h3>
              <div class="grid two">
                <div nz-form-item>
                  <div nz-form-label>
                    <label>{{ 'theme.item.font.size.message' | i18n }}</label>
                  </div>
                  <div nz-form-control>
                    <input nz-input [(ngModel)]="themeConfig.fontSize.base" name="fontSizeBase" testId="theme-item-font-size-base-input" />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="preview-column">
        <div class="section-card preview-card">
          <h3 class="section-title">{{ 'theme.item.preview.title' | i18n }}</h3>
          <div
            class="chat-preview"
            [style.background]="themeConfig.backgroundColor"
            [style.box-shadow]="themeConfig.boxShadow.medium"
            [style.border-radius]="themeConfig.windowRadius"
            [testId]="'theme-item-chat-preview'"
          >
            <div class="chat-header" [style.background]="themeConfig.headerBg" [style.color]="themeConfig.headerTextColor">
              <span class="avatar"></span>
              <div class="header-info">
                <div class="name">{{ 'theme.item.preview.header' | i18n }}</div>
                <div class="status" style="color: #6b7280">{{ 'common.online' | i18n }}</div>
              </div>
            </div>
            <div class="chat-messages">
              <div class="message-row service">
                <span class="avatar"></span>
                <div
                  class="message service"
                  [style.background]="themeConfig.agentBubbleBg"
                  [style.color]="themeConfig.agentBubbleText"
                  [style.border-radius]="themeConfig.bubbleRadius"
                  [style.box-shadow]="themeConfig.boxShadow.medium"
                  [style.font-size]="themeConfig.fontSize.base"
                >
                  {{ 'theme.item.preview.service-message.example' | i18n }}
                </div>
              </div>
              <div class="message-row user">
                <div
                  class="message user"
                  [style.background]="themeConfig.customerBubbleBg"
                  [style.color]="themeConfig.customerBubbleText"
                  [style.border-radius]="themeConfig.bubbleRadius"
                  [style.box-shadow]="themeConfig.boxShadow.medium"
                  [style.font-size]="themeConfig.fontSize.base"
                >
                  {{ 'theme.item.preview.user-message.example' | i18n }}
                </div>
              </div>
              <div class="message-row service">
                <span class="avatar"></span>
                <div
                  class="message service"
                  [style.background]="themeConfig.agentBubbleBg"
                  [style.color]="themeConfig.agentBubbleText"
                  [style.border-radius]="themeConfig.bubbleRadius"
                  [style.box-shadow]="themeConfig.boxShadow.medium"
                  [style.font-size]="themeConfig.fontSize.base"
                >
                  {{ 'theme.item.preview.service-message.example' | i18n }}
                </div>
              </div>
            </div>
            <div class="chat-input" [style.background]="themeConfig.footerBg">
              <div class="input-with-action">
                <input
                  nz-input
                  [placeholder]="'theme.item.preview.input-placeholder' | i18n"
                  style="color: #1f2937"
                  testId="theme-item-preview-input"
                />
                <button
                  nz-button
                  nzType="primary"
                  class="send-btn"
                  [style.background-color]="themeConfig.primaryColor"
                  [style.border-color]="themeConfig.primaryColor"
                  style="color: #ffffff"
                  testId="theme-item-preview-send-button"
                >
                  <i nz-icon nzType="send" nzTheme="outline"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nz-spin>
</nz-card>
